import "./DashboardComponent.css";
import DashNavbar from "./fragments/DashNavbar";
import { useNavigate } from "react-router-dom";
import ChildWrapper from './utils/ChildWrapper';

export default function DashboardComponent() {
  const buttons = ["Fatture", "Inventario", "Impostazioni", "Logout"];
  const navigate = useNavigate();

  return (
    <div className="dash-component shadow-drop-center">
      <div className="dash-component__border">
        <div className="dash-component__board shadow-inset-center glass-effect">
          <DashNavbar
            buttons={buttons}
            onSelect={(btn) => navigate(btn.path)}
          />
          <div className="dash-component__content">
            {/* ChildWrapper si occupa di mostrare il loader quando outletContext.loading è true */}
            <ChildWrapper />
          </div>
        </div>
      </div>
    </div>
  );
}
